var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 6.6665H8.33333C7.41286 6.6665 6.66666 7.4127 6.66666 8.33317V14.9998C6.66666 15.9203 7.41286 16.6665 8.33333 16.6665H15C15.9205 16.6665 16.6667 15.9203 16.6667 14.9998V8.33317C16.6667 7.4127 15.9205 6.6665 15 6.6665Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66683V5.00016C13.3333 4.55814 13.1577 4.13421 12.8452 3.82165C12.5326 3.50909 12.1087 3.3335 11.6667 3.3335H5C4.55798 3.3335 4.13405 3.50909 3.82149 3.82165C3.50893 4.13421 3.33334 4.55814 3.33334 5.00016V11.6668C3.33334 12.1089 3.50893 12.5328 3.82149 12.8453C4.13405 13.1579 4.55798 13.3335 5 13.3335H6.66667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d80cf01bfaf5e5613d361686b3b79926.svg";
export { ForwardRef as ReactComponent };